import type { FunctionComponent, ReactNode } from 'react';
import { useCallback, useMemo } from 'react';

import { DevToolsToggle } from '../DevToolsToggle';

interface UrlParamToggleProps {
    label: ReactNode;
    paramName: string;
}

export const UrlParamToggle: FunctionComponent<UrlParamToggleProps> = ({ label, paramName }) => {
    const isUrlParamEnabled = useMemo(() => {
        const searchParams = new URLSearchParams(window.location.search);
        return searchParams.get(paramName) === 'true';
    }, [paramName]);

    const toggleUrlParam = useCallback(
        (isActive: boolean) => {
            const searchParams = new URLSearchParams(window.location.search);

            if (isActive) {
                searchParams.set(paramName, 'true');
            } else {
                searchParams.delete(paramName);
            }

            window.location.search = searchParams.toString();
        },
        [paramName],
    );

    return <DevToolsToggle active={isUrlParamEnabled} label={label} onToggle={toggleUrlParam} />;
};
